import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { Stripe, SubmitAppReturn } from "api";
import { Credentials } from "auth";
import { State } from "redux/state";
import { getString } from "utils/Utils";

export type SubmitApp = "SUBMIT_APP";
export const SUBMIT_APP: SubmitApp = "SUBMIT_APP";
export type SubmitAppEnd = "SUBMIT_APP_END";
export const SUBMIT_APP_END: SubmitAppEnd = "SUBMIT_APP_END";

export interface SubmitAppAction extends Action {
    payload: {
        credentials: Credentials;
        appId: string;
        payments: Stripe;
    };
    type: SubmitApp;
}

export function submitApp(
    app: string | { appId: string },
    payments?: Stripe
): ThunkAction<void, State, undefined, SubmitAppAction> {
    return (dispatch: Dispatch<SubmitAppAction>, getState) => {
        const credentials = getState().auth.credentials;
        dispatch(submitAppWithCredentials(credentials, app, payments));
    };
}

function submitAppWithCredentials(
    credentials: Credentials,
    app: string | { appId: string },
    payments?: Stripe
): SubmitAppAction {
    return {
        payload: {
            appId: getString(app, "appId"),
            credentials,
            payments
        },
        type: SUBMIT_APP
    };
}

export interface SubmitAppEndAction extends Action {
    payload: {
        error?: Error;
        result?: SubmitAppReturn;
    };
    type: SubmitAppEnd;
}

export function submitAppEnd(error: Error, result?: SubmitAppReturn): SubmitAppEndAction {
    return {
        payload: {
            error,
            result
        },
        type: SUBMIT_APP_END
    };
}
